import React, { useEffect, useState } from "react";
import EmailIcon from '../../../assets/images/Union.svg';
import { Button, Input, Select, CheckedImage, PhoneNumber } from '../../../common/commonIndex';
import { StepOTC, StepEmail, StepName, StepProfile, StepSex, StepDOB, StepPhoneNumber } from './stepIndex'
import { useNavigate, useSearchParams } from 'react-router-dom';
import useAuthentication from "../../../hooks/userAuthenticatication/useAuthentication";
import PersonalInformationService from '../../../services/API/personalInformationService';
import { useAuthenticationContext } from "../../../services/slices/AuthenticationSlicer";
import { toast } from "react-toastify";
import LocationService from '../../../services/API/locationService';
import axiosConfig from "../../../services/axiosConfig";
// import { useAuth } from "../../../services/slices/AuthenticationSlicer";

const countryCodes = [
    { code: '+1', name: 'United States' },
    { code: '+44', name: 'United Kingdom' },
    { code: '+91', name: 'India' }
    // Add more country codes as needed
];

const StepLogin = ({ step, handleNext, formValues, setFormValues }) => {
    const [searchParams] = useSearchParams();
    const [selectedCountry, setSelectedCountry] = useState('+1');
    const [mobileNumber, setMobileNumber] = useState(formValues.mobileNumber || '');
    const [isMobileValid, setIsMobileValid] = useState(true);
    const [isSubmit, setIsSubmit] = useState(true);
    const [isEmail, setIsEmail] = useState(false);
    const phoneRegex = /^[0-9]{10,}$/;
    const { state: data } = useAuthenticationContext();
    const [personalInfo, setPersonalInfo] = useState({});
    const { login, redirectPath } = useAuthenticationContext();
    let selectedDateOfBirth = '1/1/1990';
    const navigate = useNavigate(); // Use useNavigate instead of useHistory
    const { dispatchSignInWithPhone } = useAuthentication();


    useEffect(() => {
        if (formValues) {
            setMobileNumber(formValues?.mobileNumber);
            const countryCode = formValues?.countryCodes !== '' ? formValues?.countryCodes : countryCodes[0]?.code;
            setSelectedCountry(countryCode);
        } else {
            setMobileNumber('');
            setSelectedCountry(countryCodes[0]?.code);
        }

    }, [formValues]);

    const handleCountryChange = (key, value) => {
        setSelectedCountry(value);
        formValues[key] = value;
    };

    const handleInputChange = (key, value) => {
        if (key === 'mobileNumber') {
            setMobileNumber(value);
            if (value?.trim() !== '' && value?.length === 10) {
                setIsMobileValid(true);
            } else {
                setIsMobileValid(false);
            }
        }
        formValues[key] = value;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsSubmit(false);
        if (!phoneRegex.test(mobileNumber || formValues?.mobileNumber)) {
            setIsMobileValid(false);
            return;
        }
        setIsMobileValid(true);
        handleSignInWithPhone(selectedCountry, mobileNumber);
    };

    // Call Sign In With Phone Api
    const handleSignInWithPhone = async (selectedCountry, mobileNumber) => {
        try {
            const credentials = { phoneNumber: `${selectedCountry}${mobileNumber}` };
            const res = await dispatchSignInWithPhone(credentials);
            if (res && res.statusCode === 200) { // Check if response code is 200 (successful)
                formValues['session'] = res?.result?.session;
                localStorage.setItem('phoneNumber', `${selectedCountry}${mobileNumber}`);
                setIsSubmit(true);
                handleNext(1); // Proceed to next step if needed
            } else if(res?.statusCode === 422) {
                setIsEmail(true);
            } else {
                setIsSubmit(true);
                console.warn("Login unsuccessful", res.message || "Unauthorized access");
            }
        } catch (error) {
            setIsSubmit(true);
            console.error("Login failed: ", error);
        }
    }

    const handleNextEvent = async (step) => {
        if (step <= 7) {
            handleNext(step);
        } else {
            handleLogin();
        }
    };
    const handleLogin = () => {
        if (searchParams.get('callback')) {
            navigate(searchParams.get('callback'));
        } else {
            navigate("/landing");
        }
        // navigate('/landing');
    }

    const getPersonalInfo = async () => {
        // try {
        //     const accessToken = data?.userData?.result?.token
        //     const response = await PersonalInformationService.getPersonalInformation(accessToken);
        //     setPersonalInfo(response.result)
        //     if (response?.statusCode === 200) {
        //         toast.success(response?.message);
        //     } else {
        //         toast.error(response?.message);
        //     }
        //     return response;
        // } catch (error) {
        //     console.error("Login failed: ", error);
        // }
    }

    const fetchIpLocation = async (personalInfoRequest) => {
        updateInformation(personalInfoRequest, data);
        // const response = fetch('http://ip-api.com/json/')
        //     .then((response) => response.json())
        //     .then((data) => {
        //         // Update Personal Information
        //         updateInformation(personalInfoRequest, data);
        //     })
        //     .catch((error) => console.error("Error fetching IP/location data:", error));
    };

    const updatePersonalInfo = async (personalInfoRequest) => {
        // get current location
        fetchIpLocation(personalInfoRequest);
    }

    const findDateOfBirth = (personalInfoRequest) => {
        return `${personalInfoRequest?.month ? personalInfoRequest.month : 1}/${personalInfoRequest?.day ? personalInfoRequest.day : 1
            }/${personalInfoRequest?.year ? personalInfoRequest.year : 1990}`;
    }
    const handleSetDateOfBirth = (date) => {
        selectedDateOfBirth = `${date?.month ? date.month : 1}/${date?.day ? date.day : 1
            }/${date?.year ? date.year : 1990}`;
    }
    const updateInformation = async (personalInfoRequest, locationData) => {
        const genderId = personalInfoRequest?.sex === 'Male' ? 2 : 3;
        const DOB = selectedDateOfBirth ? selectedDateOfBirth : findDateOfBirth(personalInfoRequest);
        let phoneNumber = personalInfo.phoneNumber && personalInfo.phoneNumber !== '' ? personalInfo.phoneNumber : personalInfoRequest.countryCodes + personalInfoRequest.mobileNumber;
        if (phoneNumber && phoneNumber?.length < 10) {
            phoneNumber = localStorage.getItem('phoneNumber');
        }

        let formattedDateOfBirth;
        if (personalInfo.dateOfBirth) {
            const dateObj = new Date(personalInfo.dateOfBirth);
            // Format the date into yyyy/mm/dd
            formattedDateOfBirth = `${dateObj.getMonth() + 1}/${dateObj.getDate()}/${dateObj.getFullYear()}`;
        }
        const updatePersonalInfoRequest = {
            "fkUserId": personalInfo.fkUserId,
            "firstName": personalInfoRequest?.firstName ? personalInfoRequest?.firstName : personalInfo.firstName,
            "lastName": personalInfoRequest?.lastName ? personalInfoRequest?.lastName : personalInfo.lastName,
            "fkGenderId": genderId ? genderId : personalInfo.fkGenderId,
            // "fkPronounId": personalInfo.fkPronounId ? personalInfo.fkPronounId : null,
            //"address": locationData?.city + ', ' + locationData?.country,
            // "fkCityId": personalInfo.fkCityId ? personalInfo.fkCityId : null,
            // "fkStateId": personalInfo.fkStateId ? personalInfo.fkStateId : null,
            // "fkZipCodeId": personalInfo.fkZipCodeId ? personalInfo.fkZipCodeId : null,
            "phoneNumber": phoneNumber,
            "emailAddress": personalInfoRequest?.email !== '' ? personalInfoRequest?.email : personalInfo.emailAddress,
            // "stateName": personalInfo.stateName,
            "listOfCities": personalInfo.listOfCities,
            "listOfZipCode": personalInfo.listOfZipCode,
            // "profileSignedUrl": personalInfoRequest?.profile ? personalInfoRequest?.profile : personalInfo.profileSignedUrl,
            "dateOfBirth": DOB ? DOB : formattedDateOfBirth
        }

        try {
            const accessToken = data?.userData?.result?.token;
            const response = await PersonalInformationService.updatePersonalInformation(updatePersonalInfoRequest, accessToken);
            if (response?.statusCode === 200) {
                const userData = JSON.parse(localStorage.getItem('userData'));
                userData.result.first_name = personalInfoRequest?.firstName ? personalInfoRequest?.firstName : personalInfo?.firstName;
                userData.result.last_name = personalInfoRequest?.lastName ? personalInfoRequest?.lastName : personalInfo?.lastName;
                userData.result.email = personalInfoRequest?.email !== '' ? personalInfoRequest?.email : personalInfo?.emailAddress;
                localStorage.setItem('userData', JSON.stringify(userData));
                localStorage.removeItem('phoneNumber');
                handleLogin();
                // toast.success(response?.message);
            }
            return response;
        } catch (error) {
            console.error("Login failed: ", error);
        }
    }

    const renderStep = (step) => {

        switch (step) {
            case 0:
                return (
                    <StepPhoneNumber
                        countryCodes={countryCodes}
                        selectedCountry={selectedCountry}
                        formValues={formValues}
                        phoneRegex={phoneRegex}
                        mobileNumber={mobileNumber}
                        handleCountryChange={handleCountryChange}
                        handleInputChange={handleInputChange}
                        handleSubmit={handleSubmit}
                        isSubmit={isSubmit}
                        handleNextEvent={handleNextEvent}
                        currentUser={data?.userData?.result || null}
                        isEmailShow={isEmail}
                        setIsEmailShow={setIsEmail}
                    />
                );
            case 1:
                return <StepOTC handleNextEvent={handleNextEvent} formData={formValues} setPersonalInfo={setPersonalInfo} />;
            case 2:
                return <StepEmail handleNextEvent={handleNextEvent} formData={formValues} getPersonalInfo={getPersonalInfo} setFormValues={setFormValues} updatePersonalInfo={updatePersonalInfo} currentUser={data?.userData?.result || null} countryCodes={countryCodes} />;
            case 3:
                return <StepName handleNextEvent={handleNextEvent} formData={formValues} getPersonalInfo={getPersonalInfo} updatePersonalInfo={updatePersonalInfo} />;
            case 4:
                return <StepProfile handleNextEvent={handleNextEvent} formData={formValues} getPersonalInfo={getPersonalInfo} updatePersonalInfo={updatePersonalInfo} currentUser={data?.userData?.result || null} />;
            case 5:
                return <StepSex handleNextEvent={handleNextEvent} formData={formValues} getPersonalInfo={getPersonalInfo} updatePersonalInfo={updatePersonalInfo} />;
            case 6:
                return <StepDOB handleNextEvent={handleNextEvent} formData={formValues} getPersonalInfo={getPersonalInfo} updatePersonalInfo={updatePersonalInfo} setFormValues={setFormValues} handleSetDateOfBirth={handleSetDateOfBirth} />;
            default:
                return <div>Invalid step</div>
        }
    };

    return (
        <div>
            <div className={step === 1 ? 'login-container' : ''}>
                {renderStep(step)}
            </div>
        </div>

    );
}

export default StepLogin;
